import React, { useState, useEffect } from "react";
//components
import Container from "../../../components/container/container";
//images and icons
import DeleteIcon1 from "../../../assets/images/pictures/delete-account.png";
import DeleteIcon2 from "../../../assets/images/pictures/delete-account1.png";

export default function DeleteAccount() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    if (document.documentElement.classList.contains("dark")) {
      setIsDarkMode(true);
    }
  }, []);

  return (
    <div data-test="help-page">
      <div className="min-h-96 bg-cover no-repeat bg-center relative z-0">
        <div className="border-b dark:border-[#BCBCBC]">
          <h2 className="text-xl sm:text-2xl py-3 text-center font-medium">
            Delete Your Account?
          </h2>
        </div>
        <Container>
          <div className="max-w-lg px-6 mx-auto py-4 sm:py-10">
            {isDarkMode ? (
              <img src={DeleteIcon2} alt="DeleteIcon" />
            ) : (
              <img src={DeleteIcon1} alt="DeleteIcon" />
            )}
          </div>
        </Container>
      </div>

      <Container>
        <main>
          <div className="max-w-3xl mx-auto lg:max-w-7xl">
            <h1 className="sr-only">Delete Your Account Page</h1>

            <section aria-labelledby="section-1-title">
              {/* Your content */}

              <div className="mt-10 bg-white dark:bg-[#121212] rounded-[24px] px-4 sm:px-12 py-8">
                <div className="mb-8">
                  <h3 className="text-[20px] sm:text-[25px] mb-2">
                    <span className="font-bold mr-1 sm:mr-4">App Name:</span>
                    <span>Ogwugo Food</span>
                  </h3>
                  <p className="text-lg">
                    Your account and all associated data will be deleted
                    immediately upon request. We take your privacy seriously and
                    ensure prompt removal.
                  </p>
                </div>

                <div className="mb-8">
                  <h3 className="text-[20px] sm:text-[25px] mb-2">
                    <span className="font-bold mr-1 sm:mr-4">
                      Data that will be deleted:
                    </span>
                    <span>Your account details</span>
                  </h3>
                  <p className="text-lg">
                    (email, username), user-generated content, and interaction
                    history
                  </p>
                </div>
                <div className="mb-8">
                  <h3 className="text-[20px] sm:text-[25px] mb-2">
                    <span className="font-bold mr-1 sm:mr-4">
                      Data we may retain:
                    </span>
                    <span>Transaction logs</span>
                  </h3>
                  <p className="text-lg">
                    (for up to 30 days for auditing), anonymized usage
                    statistics.
                  </p>
                </div>
              </div>

              <div className="mt-10 bg-white dark:bg-[#121212] rounded-[24px] px-4 sm:px-12 py-8">
                <div className="mb-8">
                  <h3 className="font-bold text-[20px] sm:text-[25px] mb-4">
                    Steps to Instant Account Deletion:
                  </h3>

                  <h3 className="text-[20px] sm:text-[25px] mb-3">
                    <span className="font-bold mr-1 sm:mr-4">Step 1:</span>
                    <span>Log in to your account at food.ogwugo.com</span>
                  </h3>
                  <h3 className="text-[20px] sm:text-[25px] mb-3">
                    <span className="font-bold mr-1 sm:mr-4">Step 2:</span>
                    <span>
                      Navigate to your profile and select{" "}
                      <span className="text-primary">Delete Account</span>{" "}
                      option.
                    </span>
                  </h3>
                  <h3 className="text-[20px] sm:text-[25px] mb-3">
                    <span className="font-bold mr-1 sm:mr-4">Step 3:</span>
                    <span>
                      Describe your experience and enter your email to confirm
                      account deletion.
                    </span>
                  </h3>
                  <h3 className="text-[20px] sm:text-[25px] mb-3">
                    <span className="font-bold mr-1 sm:mr-4">Step 4:</span>
                    <span>
                      Click Delete Button to instantly delete your account.
                    </span>
                  </h3>
                </div>
              </div>
            </section>
          </div>
        </main>
      </Container>
    </div>
  );
}
